module.exports = __webpack_public_path__ + "static/senalizacion-aa39f235b7b7fd53001723f2aa76cbfb.svg";